module.exports = __webpack_public_path__ + "static/media/15.jpg.c2a26ae3.webp";